import React from 'react';
import PropTypes from 'prop-types';

import Divider from 'learn-common-divider';

import styles from './Subtitle.scss';

export const Subtitle = ({ headerTitle }) => (
  <div className={`${styles.subtitle} d-none d-lg-block`}>
    <Divider light thick />
    <svg height="100%" viewBox="0 0 300 24" width="100%" xmlns="http://www.w3.org/2000/svg">
      <text lengthAdjust="spacing" textLength="300" x="0" y="14">
        {headerTitle}
      </text>
    </svg>
  </div>
);

Subtitle.propTypes = {
  headerTitle: PropTypes.string.isRequired
};

export default Subtitle;
